<template>
  <div class="download_wrap">
    <section class="download_wrap_logo">
      <img class="logo" :src="zzLogo" alt="" />
    </section>
    <section class="download_wrap_btn">
      <div class="btn" id="chx_download">
        {{ btnText }}
      </div>
      <div class="tips">
        {{ tips }}
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import { initPage } from '../utils'

const zzLogo = 'https://pic3.zhuanstatic.com/zhuanzh/n_v21f618270dfb244468d7d656ad37ff164.png?w=200&h=200'
const tips = '如果不能正常打开采货侠，请在浏览器中打开之前链接'
const btnText = '立即打开'

export default {
  name: 'CHXDownload',
  mounted() {
    document.title = '采货侠'
    initPage('#chx_download')
  },
  data() {
    return {
      zzLogo,
      tips,
      btnText,
    }
  },
}
</script>

<style lang="scss" scoped>
.download_wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &_logo {
    width: 100%;
    margin-top: 100px;
    margin-bottom: 75px;

    .logo {
      width: 120px;
      height: 120px;
      display: block;
      margin: 0 auto;
    }
  }

  &_btn {
    width: 100%;

    .btn {
      font-size: 15px;
      line-height: 43px;
      color: rgb(255, 0, 0);
      margin: 0 auto;
      width: 190px;
      height: 43px;
      background-color: #fff;
      // border: 1px solid rgb(163, 135, 135);
      letter-spacing: 1px;
    }

    .tips {
      margin: 10px auto;
      font-size: 12px;
      color: #9a9a9a;
      font-weight: 500;
    }
  }
}
</style>
